const hy = {
  text: 'Սեղմիր համարի վրա՝ UX Core-ում հակումը բացելու համար',
  tip: 'in a new tab',
};

export default hy;
